<!--
 * @Author: zouyuping
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-16 09:59:48
 * @FilePath: 
 * @Description: 挂号历史页
-->
<template>
  <div class="page-container">
    <!-- goods-list -->
    <div class="tab-list">
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="loadError"
        :immediate-check="false"
        :offset="30"
        error-text="请求失败，点击重新加载"
        finished-text=""
        @load="onLoad"
      > -->
      <div
        v-for="(v, i) in historyList"
        :key="i"
        class="c-bg-white c-m-b-20 history_item_con"
        @click="onCheckDetail(v.Id)"
      >
        <div class="c-p-lr-24">
          <div class="c-fl-bt history_top_con">
            <div>{{ v.Creation }}</div>
            <div :class="v.Status == 4 ? 'c-lightgrey' : 'c-tc'">
              {{ statusObj[v.Status] }}
            </div>
          </div>
          <div class="history_bottom_con">
            <div class="f-bt c-m-b-15">
              <div class="c-f">
                <span class="order_name_con">会员卡</span
                ><span>{{ v.CardTypeName }}</span>
              </div>
              <div>
                {{ v.Number }}
              </div>
            </div>
            <div class="c-f c-m-b-15">
              <span class="order_name_con">预约项目</span>
              <span>{{ v.GoodsName }}</span>
            </div>
            <div class="c-f c-m-b-15">
              <p class="w-60% c-f" v-if="showJIshi">
                <span class="order_name_con">预约诊疗师</span>
                <span>{{ v.JiShiName }}</span>
              </p>
              <p class="w-40% c-f" v-if="isNeedCheckNumber">
                <span class="order_name_con">预约人数</span>
                <span>{{ v.BookingNumberOfPeople }}</span>
              </p>
            </div>
            <div class="c-f">
              <span class="order_name_con">预约时间</span>
              <span>{{ v.PeriodTime }}</span>
            </div>
          </div>

          <!-- <div class="c-tr" v-if="v.Status.Id == 1">
          <van-button
            type="info"
            color="var(--tc)"
            size="mini"
            round
            @click="lookCode(v)"
            >查看消费码</van-button
          >
        </div> -->
        </div>
      </div>
      <!-- </van-list> -->
    </div>
    <van-empty
      v-if="historyList.length === 0"
      description="您暂时没有相关记录"
    />
    <!-- <g-no-content
      v-if="historyList.length === 0"
      title="您暂时没有相关订单"
    ></g-no-content> -->
  </div>
</template>

<script>
import { handleTimeLocalStorage } from "@/utils";
import { getBookRegisterHistory } from "@/api/bookRegister";
export default {
  name: "Order",
  data() {
    return {
      statusObj: { 1: "已挂号", 2: "已叫号", 3: "已就诊", 4: "已取消" },
      historyList: [],
      loading: false,
      refreshing: false,
      finished: false,
      loadError: false,

      pageIndex: 1,
      pageSize: 10,
      showJIshi: false,
      isNeedCheckNumber: false,
    };
  },

  created() {
    this.init();
    const bookConfigData = handleTimeLocalStorage.get("bookConfig");
    this.showJIshi = bookConfigData.JsStatusId == 1;
    this.isNeedCheckNumber = bookConfigData.BookingNumberOfPeople == 1;
  },

  methods: {
    // 初始化
    async init() {
      // this.resetParams();
      // 加载产品列表前5条数据
      this.getOrderList();
    },

    getOrderList() {
      getBookRegisterHistory({ VpnId: this.$store.state.vpnId }).then((res) => {
        res.forEach((element) => {
          element.PeriodTime =
            element.Taken.split(" ")[0] + " " + element.TimeSpan;
        });
        this.historyList = res;
        //     let resDatas = res.Items;
        //     if (Array.isArray(resDatas)) {
        //       this.historyList = this.historyList.concat(resDatas);
        //       if (this.historyList.length >= res.Pager.TotalCount) {
        //         this.finished = true;
        //       }
        //     }
        //     // debugger
        // this.loading = false;
        // this.refreshing = false;
        //   })
        //   .catch(() => {
        //     this.loading = false;
        //     this.finished = true;
        //   })
        //   .finally(() => {
      });
    },

    // 上拉加载
    onLoad() {
      // this.pageIndex += 1;
      this.getOrderList();
    },

    resetParams() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 1;
      this.historyList = [];
    },

    // 查看产品详情
    onCheckDetail(orderId) {
      this.$router.push({
        name: "BookRegisterOrderDetail",
        query: { BookId: orderId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 32px;
}
.history_item_con {
  border-radius: 12px;
}
.history_top_con {
  line-height: 70px;
  border-bottom: 1px dashed #dedede;
  font-size: 22px;
}
.history_bottom_con {
  padding: 23px 0;
  font-size: 24px;
  color: #333;
}
.order_name_con {
  width: 130px;
  color: #666;
  font-size: 22px;
}
</style>
